import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import moment from 'moment';
// Types
import { SalesOrderProps } from 'types/salesOrder';
// Auth Context
// import { useAuthState } from 'context/AuthContext';
// Sales Context
// import { useSalesOrderState } from 'context/SalesOrderContext';
// import * as salesFlags from 'context/SalesOrderContext/statusFlags';
// Utils
import { useSetState } from 'utils';
import { setBadgeType } from 'utils/events';
import { getSalesOrderCellData } from 'utils/salesOrder';
// Assets
import Icon from 'assets/Icon';
// Elements
import Badge from 'elements/Badge';
import Button from 'elements/Button';
import ListCell from 'elements/ListCell';
// Components
import SubSalesOrder from './SubSalesOrder';
// Styles
import styles from './style/salesOrder.module.css';

interface EventProps {
  event: SalesOrderProps,
}

function SalesOrder({
  event,
}:EventProps) {
  // interface OrderLinesProps {
  //   targetSalesOrder: number,
  //   salesOrderLineId: number,
  //   targetItemNumber: number,
  //   orderedQuantity: number,
  //   itemId: number,
  //   pack_id: string,
  //   unitOfMeasure: string,
  //   purchaseOrderRef: number,
  //   processingStatus: string,
  //   supplierId: string,
  //   errorStatus: string,
  //   lineId: number,
  //   packSite: string,
  // }
  
  // const {
  //   // orderInfo: {
  //   //   // orderId,
  //   //   // action,
  //   //   // orderType,
  //   //   // source,
  //   //   // purchaseOrderRef,
  //   //   // processingStatus,
  //   //   // createdDate,
  //   //   // errorMessage,
  //   // },
  //   customer: {
  //     shipTo: {
  //       locationId,
  //       deliveryDate,
  //     },
  //   },
  //   orderLines: OrderLinesProps,
  // } = event;
  
  // Ref
  const resolvePopover = useRef<HTMLLIElement>(null);
  // State
  const defaultState = useMemo(() => ({
    expandEvent: false,
    popover: false,
  }), []);
  const [state, setState] = useSetState(defaultState);
  const expandable = event.orderLines && event.orderLines.length > 0;

  /* const loadingData = (
    salesState === salesFlags.GET_SALES_ORDER
      || salesState === salesFlags.RESOLVE_SALES_ORDER
      || salesState === salesFlags.RESEND_SALES_ORDER
  );
  const eventPatchSuccess = (
    salesState === salesFlags.RESEND_SALES_ORDER_SUCCESS
      || salesState === salesFlags.RESOLVE_SALES_ORDER_SUCCESS
  ); */

  const handleClickOutside = useCallback((e: MouseEvent) => {
    if (e.target instanceof Element) {
      if (state.popover && resolvePopover.current && resolvePopover.current.contains(e.target)) {
        return;
      }
    }
    setState({ popover: false });
  }, [setState, state.popover]);

  /* function renderChildCellData(cell:{ label: string, value: string | number }) {
    return (
      <ListCell
        key={cell.label}
        label={cell.label}
        value={cell.value}
        responsive="1280"
      />
    );
  } */

  function renderCellData(cell:{ label: string, value: string | number }) {
    return (
      <ListCell
        key={cell.label}
        label={cell.label}
        value={cell.value}
        responsive="1280"
      />
    );
  }

  useEffect(() => {
    if (state.popover) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleClickOutside, state.popover]);

  useEffect(() => {
    setState(defaultState);
  }, [event, defaultState, setState])

  return (
    <div className={styles.container}>
      <div className={styles.main}>
        <div className={styles.processingStatus}>
          <Badge
            badgeStyle={setBadgeType((event.orderInfo.processingStatus === 'ERROR' || event.orderInfo.processingStatus === 'LINES_IN_ERROR') ? 'FAILED' : event.orderInfo.processingStatus)}
            label={(event.orderInfo.processingStatus === 'ERROR' || event.orderInfo.processingStatus === 'LINES_IN_ERROR') ? 'FAILED' : event.orderInfo.processingStatus}
          />
        </div>
        <div className={styles.details}>
          <h3 className="subtitle1">
            {event.orderInfo.purchaseOrderRef}
          </h3>
          <p className="body2">{ moment(event.customer.shipTo.deliveryDate).format('DD MMM YYYY') }</p>
        </div>
        <ul className={styles.actions}>
          <li>
            <Button
              btnSize="small"
              btnType="icon"
              disabled={!expandable}
              elevation="2-4"
              handler={() => setState({ expandEvent: !state.expandEvent })}
            >
              <Icon
                icon={state.expandEvent ? 'ExpandLess' : 'ExpandMore'}
                fill={expandable ? 'black' : 'warm-grey-200'}
              />
            </Button>
          </li>
        </ul>
        <div className={styles.cells}>
          { getSalesOrderCellData(event).map(renderCellData)}
        </div>
      </div>
      <div className={`${styles.expandedContent} ${state.expandEvent ? styles.expandedContent_active : ''}`}>
        <div className={styles.childGrid}>
          { event.orderLines.map(item =>
            <SubSalesOrder
              event={event}
              key={item.salesOrderLineId}
              childEvent={item}
            />)}
        </div>
      </div>
    </div>
  );
}

export default SalesOrder;

